import { EnvironmentTypes, SiteConfig, footerApp, headerApp, shellApp } from '@openedx/frontend-base';
import customApp from './src/customApp';
import { addApp, addExternalRoute } from './src/utils';


import { authnApp } from '@openedx/frontend-app-authn';



import { learnerDashboardApp } from '@openedx/frontend-app-learner-dashboard';



import { instructorDashboardApp } from '@openedx/frontend-app-instructor-dashboard';



import { notificationsApp } from '@openedx/frontend-app-notifications';







import '@openedx/frontend-base/shell/style';
import '@edx/brand/core.min.css';
import '@edx/brand/light.min.css';

const siteConfig: SiteConfig = {
  siteId: 'tutor-site',
  siteName: "Open edX Instance for ulmo-to-verawood",
  baseUrl: 'https://apps.ulmo-to-verawood.launchpad-ulmo-to-verawood-do.opencraft.hosting',
  cmsBaseUrl: 'https://studio.ulmo-to-verawood.launchpad-ulmo-to-verawood-do.opencraft.hosting',
  lmsBaseUrl: 'https://ulmo-to-verawood.launchpad-ulmo-to-verawood-do.opencraft.hosting',
  loginUrl: 'https://ulmo-to-verawood.launchpad-ulmo-to-verawood-do.opencraft.hosting/login',
  logoutUrl: 'https://ulmo-to-verawood.launchpad-ulmo-to-verawood-do.opencraft.hosting/logout',

  environment: EnvironmentTypes.PRODUCTION,
  apps: [
    shellApp,
    headerApp,
    footerApp,
    customApp,
  ],
  externalRoutes: [],

  runtimeConfigJsonUrl: '/api/frontend_site_config/v1/',
  accessTokenCookieName: 'edx-jwt-cookie-header-payload',
};


addApp(siteConfig, authnApp);



addApp(siteConfig, learnerDashboardApp);



addApp(siteConfig, instructorDashboardApp);



addApp(siteConfig, notificationsApp);





export default siteConfig;